export class TabModel {

  index: number;
  name: string;
  uid: number;
  tabType: number;
  clientUid: number;
  isEditing: boolean;
  previousRoute: string;
  currentRoute: string;
  activeTab: boolean;
  
  constructor() {
  }
}